import React, { useEffect } from "react";
import AboutDoctor from "./about_doctor/AboutDoctor";
import SimilarDoctors from "./similar_doctors/SimilarDoctors";
import Doctor_Rating from "./doctor_Rating/Doctor_Rating";
import { useDispatch, useSelector } from "react-redux";
import { getDoctor } from "../../../features/doctor/doctorSlice";
import { decodeId } from "../../../utils/common";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { AvgDoctorRating } from "../../../features/doctor_rating/doctor_ratingSlice";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function DoctorDetail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const doctor = useSelector((state) => state.doctor.doctor);

  const fetchDoctor = async (id) => {
    await dispatch(getDoctor(decodeId(id)));
  };

  useEffect(() => {
    if (id) {
      fetchDoctor(id);
    }
  }, [dispatch, id]);

  const avg_rating = useSelector((state) => state.doctorRating.avg_rating);

  useEffect(() => {
    dispatch(
      AvgDoctorRating({
        doctor_id: doctor.id,
      }),
    );
  }, [dispatch, doctor]);

  return (
    <div>
      <div className="container">
        <div className="back_holder" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} className="back_icon" />
          <span>Back</span>
        </div>
      </div>

      <AboutDoctor doctor={doctor} avg_rating={avg_rating} />
      <div className="container">
        <Doctor_Rating doctor={doctor} avg_rating={avg_rating} />
      </div>
      <SimilarDoctors
        user_id={doctor?.id}
        category_id={doctor?.Doctor_Detail?.category_id}
      />
    </div>
  );
}
